// Module
var code = "<react-component ,=\"\" name=\"MembershipInterruptionsList\" props=\"{\nsource: &#39;contact&#39;\n}\"></react-component>\n";
// Exports
module.exports = code;